"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useAuth, useUser } from "@clerk/nextjs";
import { useOrganization } from "@clerk/nextjs";
export default function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  const {
    isSignedIn,
    userId,
    orgRole
  } = useAuth();
  const {
    user
  } = useUser();
  const {
    organization
  } = useOrganization();

  // Track pageviews
  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture("$pageview", {
        $current_url: url
      });
    }
  }, [pathname, searchParams, posthog]);
  useEffect(() => {
    // Check the sign in status and user info,
    //    and identify the user if they aren't already
    if (isSignedIn && userId && user && !posthog._isIdentified()) {
      // Identify the user
      posthog.identify(userId, {
        organizationId: organization?.id,
        orgRole: orgRole
        //   email: user.primaryEmailAddress?.emailAddress,
        //   username: user.username,
      });
    }

    // 👉 Reset the user if they sign out
    if (!isSignedIn && posthog._isIdentified()) {
      posthog.reset();
    }
  }, [posthog, user, organization]);
  return null;
}